import { useDownloadSetPortalExamResultFileLazyQuery } from '@exam-center/graphql';
import { FileDownloadOutlinedIcon, IconButton } from '@shared/components';
import { useSnackbar } from '@shared/snackbar';
import { triggerFileDownload } from '@shared/utils';

interface DownloadExamResultFileButtonProps {
  id: string;
}

export default function DownloadExamResultFileButton(
  props: Readonly<DownloadExamResultFileButtonProps>,
) {
  const { id } = props;

  const { showPromiseSnackbar } = useSnackbar();

  const [downloadSetPortalExamResultFile, { loading: isDownloading }] =
    useDownloadSetPortalExamResultFileLazyQuery();

  const handleDownload = () => {
    showPromiseSnackbar({
      message: {
        pending: 'กำลังดาวน์โหลดข้อมูล...',
        success: 'ดาวน์โหลดข้อมูลเรียบร้อยแล้ว',
        error: 'ดาวน์โหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
      },
      promise: async () => {
        const result = await downloadSetPortalExamResultFile({
          variables: {
            downloadSetPortalExamResultFileInput: { id },
          },
        });

        const downloadUrl = result.data?.ecDownloadSETPortalExamResultFile.downloadUrl;
        if (!downloadUrl) {
          throw new Error('No download URL');
        }

        triggerFileDownload(downloadUrl);
      },
    });
  };

  return (
    <IconButton onClick={handleDownload} disabled={isDownloading}>
      <FileDownloadOutlinedIcon color='action' />
    </IconButton>
  );
}
